import { isString } from '../UNSAFE_stringUtils';

const is = (Ctor: any) => (val: any) =>
  (val != null && val.constructor === Ctor) || val instanceof Ctor;

const isNumber = is(Number);
const isNumeral = (n: any) => !isNaN(parseFloat(n)) && !isNaN(n - 0);
const isZero = (n: any) => n === 0 || n === '0';

const units = ['px', '%', 'em', 'rem', 'vh', 'vw'] as const;
const endsWithUnitRegExp = new RegExp(`(${units.join('|')})$`);

type Unit = typeof units[number];

const hasUnit = (val: any) => isString(val) && endsWithUnitRegExp.test(val);
const toUnit = (unit: Unit) => (n: string | number) =>
  isZero(n) || hasUnit(n) || !isNumeral(n) ? n : n + unit;

const px = toUnit('px');

export { isNumber, isZero, hasUnit, px };
